var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "is-widescreen has-navbar-fixed-top"
  }, [_vm._m(0), _c('section', {
    staticClass: "section container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-two-thirds content"
  }, [_c('p', [_vm._v("Prezado Coordenador, Prezada Coordenadora,")]), _c('p', [_vm._v("Esta é a página para inscrição da sua escola na Edição 2026 da Olimpíada Cearense de Matemática - OCM2026. Todo o processo de inscrição ocorrerá exclusivamente por esta página, desde a inserção dos participantes até o envio do comprovante de pagamento das inscrições, passando pelas substuições que a escola desejar efetuar. Observe, pra isso, as datas do calendário da OCM2026.")]), _c('p', [_vm._v("O código INEP da escola será o login/usuário da escola neste sistema. Clique no botão \"Cadastrar\" se a sua escola não estiver cadastrada e for seu desejo proceder com o cadastro.")]), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Cadastrar")])], 1), _c('p', {
    staticClass: "has-text-weight-bold"
  }, [_vm._v("Um mesmo coordenador poderá cadastrar mais de uma escola da sua rede de ensino, mas precisará cadastrar escola por escola, usando a código INEP da unidade a ser cadastrada.")]), _c('p', [_vm._v("A Coordenação da OCM2026 deseja todo sucesso a cada uma dos participantes da sua escola.")])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box login-box"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Código INEP",
      "type": {
        'is-danger': _vm.errors.has('inep')
      },
      "message": {
        'INEP de 8 dígitos é obrigatório': _vm.errors.first('inep')
      }
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: 'required|length:8',
      expression: "'required|length:8'"
    }],
    attrs: {
      "type": "number",
      "name": "inep"
    },
    model: {
      value: _vm.inep,
      callback: function ($$v) {
        _vm.inep = $$v;
      },
      expression: "inep"
    }
  })], 1), _c('b-field', {
    attrs: {
      "label": "Senha",
      "type": {
        'is-danger': _vm.errors.has('password')
      },
      "message": {
        'Senha de no mínimo 8 caracteres é obrigatória': _vm.errors.first('password')
      }
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: 'required|min:8',
      expression: "'required|min:8'"
    }],
    attrs: {
      "password-reveal": "",
      "type": "password",
      "name": "password",
      "autocomplete": "off"
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "field is-grouped is-grouped-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-text",
    attrs: {
      "tag": "a",
      "to": "/signup"
    }
  }, [_vm._v("Não tenho cadastro ")])], 1), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isSignInRequestInProgress
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar ")])])])], 1)])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(" Olimpíada Cearense de Matemática 2026 ")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(" Provas em 6 de junho de 2026"), _c('br'), _vm._v(" Colégio Ari de Sá Cavalcante, sedes Duque de Caxias e Major Facundo ")])])])]);
}];
export { render, staticRenderFns };